import type { ReactNode } from 'react';

export interface SectionTitleProps {
    children: ReactNode;
    subtitle?: string;
    align?: 'left' | 'center' | 'right';
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const alignStyles = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
};

const sizeStyles = {
    sm: 'text-xl md:text-2xl',
    md: 'text-2xl md:text-3xl',
    lg: 'text-3xl md:text-4xl',
};

export function SectionTitle({ children, subtitle, align = 'center', size = 'md', className = '' }: SectionTitleProps) {
    return (
        <div className={`mb-8 ${alignStyles[align]} ${className}`}>
            <h2 className={`font-font-s font-bold text-main-color ${sizeStyles[size]}`}>{children}</h2>
            {subtitle && <p className="mt-2 text-gray-600 font-font-s text-lg">{subtitle}</p>}
        </div>
    );
}
